import { BorderedContainer } from '../../common/BorderedContainer';
import { formatDateTime } from '../../common/converters';
import { SectionTitle } from '../../common/SectionTitle';
import { InfoDisplay } from '../common/InfoDisplay';
import {
  IncidentDetail,
  PatientTimeSeries,
} from 'sections/niigata/features/IncidentDetail/useIncidentDetailForNiigata';

type Props = {
  /** 事案情報、ピックした型に変更？ */
  incidentInfo: IncidentDetail;
  /** 時系列情報 */
  timeSeries?: PatientTimeSeries;
};

/** 事案情報のコンポーネント */
export const JianInformation = ({ incidentInfo, timeSeries }: Props) => {
  return (
    <div className="flex flex-col gap-[16px]">
      <SectionTitle text="事案情報" />
      <BorderedContainer>
        <div className="flex flex-col gap-[24px]">
          <div className="flex gap-[40px] xl:gap-[96px]">
            <InfoDisplay
              title="出動番号"
              content={incidentInfo.incidentNo ?? ''}
            />
            <InfoDisplay
              title="事故種別"
              content={incidentInfo.incidentType ?? ''}
            />
            <InfoDisplay
              title="出動場所"
              content={incidentInfo.telegramTargetAddress ?? ''}
            />
          </div>
          <div className="flex flex-wrap gap-x-[40px] xl:gap-x-[96px] gap-y-[24px]">
            <InfoDisplay
              title="覚知"
              content={formatDateTime(incidentInfo.recognitionAt)}
            />
            <InfoDisplay
              title="指令"
              content={formatDateTime(incidentInfo.telegramAt)}
            />
            <InfoDisplay
              title="出動"
              content={formatDateTime(incidentInfo.departureAt)}
            />
            <InfoDisplay
              title="現着"
              content={formatDateTime(incidentInfo.siteArrivalAt)}
            />
            <InfoDisplay
              title="患者接触"
              content={formatDateTime(timeSeries?.patientContactAt ?? '')}
            />
            <InfoDisplay
              title="車内収容"
              content={formatDateTime(
                timeSeries?.ambulanceAccommodationAt ?? ''
              )}
            />
            <InfoDisplay
              title="現発"
              content={formatDateTime(timeSeries?.siteDepartureAt ?? '')}
            />
            <InfoDisplay
              title="病着"
              content={formatDateTime(timeSeries?.hospitalArrivalAt ?? '')}
            />
            <InfoDisplay
              title="収容"
              content={formatDateTime(timeSeries?.handoverAt ?? '')}
            />
            <InfoDisplay
              title="引揚"
              content={formatDateTime(incidentInfo.hospitalDepartureAt)}
            />
            <InfoDisplay
              title="帰署"
              content={formatDateTime(incidentInfo.returnAt)}
            />
          </div>
        </div>
      </BorderedContainer>
    </div>
  );
};
